import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

/**
 * Detect the base URL of the currently-executing script so that widget IIFE
 * bundles loaded from a third-party domain can resolve translation files
 * relative to their own hosting location rather than the host page's origin.
 *
 * Falls back to Vite's build-time `BASE_URL` for the normal SPA flow.
 */
function resolveTranslationBasePath(): string {
  if (typeof document !== 'undefined') {
    const scripts = document.getElementsByTagName('script');
    const currentScript = document.currentScript as HTMLScriptElement | null;
    const src = currentScript?.src ?? scripts[scripts.length - 1]?.src ?? '';

    if (src && src.includes('widgets.')) {
      const lastSlash = src.lastIndexOf('/');
      return lastSlash >= 0 ? src.substring(0, lastSlash + 1) : '';
    }
  }

  return import.meta.env.BASE_URL as string;
}

/**
 * Resolves when the active language's namespaces are loaded from the HTTP backend.
 * Await before mounting the app (see `main.tsx`) so the first paint has translations.
 */
export const i18nReady = i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${resolveTranslationBasePath()}locales/{{lng}}/translation.json`,
    },
  });

export default i18n;
